export default __webpack_public_path__ + "static/media/other-main-up-arrow.3e63d9ca.svg";